import * as React from 'react';
import { CnImageViewer } from '@/components/cn-image-viewer';
import { FormatText } from './text';
import classNames from 'classnames';
export const FormatImageText = (props) => {
    const { value, mode } = props;
    if (value && Array.isArray(value)) {
        return (React.createElement(React.Fragment, null, value.map((item) => (React.createElement("div", null,
            React.createElement(FormatText, { mode: mode, value: item }))))));
    }
    if (typeof value === 'string') {
        return (React.createElement("div", { className: classNames('cn-ui-m-card-items-format-image-text-img', {
                'format-is-simple': mode === 'simple',
            }), style: { backgroundImage: `url(${value})` }, onClick: (e) => {
                if (mode === 'simple')
                    return;
                e.stopPropagation();
                CnImageViewer.open({ src: value });
            } }));
    }
    if (value && typeof value === 'object') {
        const { url, title, content } = value;
        return (React.createElement("div", { className: "cn-ui-m-card-items-format-image-text" },
            url ? (React.createElement("div", { className: classNames('cn-ui-m-card-items-format-image-text-img', {
                    'format-is-simple': mode === 'simple',
                }), style: { backgroundImage: `url(${url})` }, onClick: (e) => {
                    if (mode === 'simple')
                        return;
                    e.stopPropagation();
                    CnImageViewer.open({ src: url });
                } })) : null,
            title && mode !== 'simple' ? (React.createElement("div", { className: "cn-ui-m-card-items-format-image-text-title" },
                React.createElement(FormatText, { mode: mode, value: title }))) : null,
            content && mode !== 'simple' ? (React.createElement("div", { className: "cn-ui-m-card-items-format-image-text-content" },
                React.createElement(FormatText, { mode: mode, value: content }))) : null));
    }
    return React.createElement(React.Fragment, null, "- -");
};
